import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class SkuWatchComponent {
    constructor() {
        this.componentSelector = "#discountreport";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        instance.search(instance);

        //$('#startdate').off().on('blur', function () {
        //    instance.search(instance);
        //});



        //$('#enddate').off().on('blur', function () {
        //    instance.search(instance);
        //});
        $('.js-seach-discounts').on('click', function () {
            instance.search(instance);
        });

        $('#enddate').off().on('blur', function () {
            instance.search(instance);
        });

        $('.js-download-excel').off().on('click', function () {
            instance.download(instance);
        });
    }

    search(instance) {
        $('#loader').show();
        $('#report').hide();
        var startDate = $('#startdate').val();
        var endDate = $('#enddate').val();
        axios({
            method: 'get',
            url: "/report/GetDiscountReport?startDate=" + startDate + "&endDate=" + endDate,
            data: {}
        }).then(function (response) {
            $('#loader').hide();
            $('#report').show();
            instance.render(instance, response.data);
        }).catch(function (response) {
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    render(instance, data) {

        if (instance.grid == null) {
            instance.grid = {
                columnDefs: [
                    { headerName: 'Marknad', field: 'MarketName', resizable: true   },
                    { headerName: 'Ordernummer', field: 'OrderNumber', resizable: true   },
                    { headerName: 'Säljar-id', field: 'SellerId', resizable: true   },
                    { headerName: 'Säljare', field: 'SellerName', resizable: true },
                    { headerName: 'Kundnummer', field: 'CustomerNumber', resizable: true },
                    { headerName: 'Företag', field: 'CustomerName', resizable: true },
                    { headerName: 'Salong', field: 'CustomerSaloon', resizable: true },
                    { headerName: 'Orderdatum', field: 'OrderDate', resizable: true   },
                    { headerName: 'Totalt fakturerat värde', field: 'TotalOrderValue', resizable: true  },
                    { headerName: 'Totalt ordervärde', field: 'TotalOriginalOrderValue', resizable: true  },
                    { headerName: 'Total rabatt mot listpris', field: 'TotalDiscount', resizable: true  },
                    { headerName: 'Total manuell rabatt', field: 'TotalSellerDiscountOnOrder', resizable: true },
                    { headerName: 'Manuella rabattrader', field: 'DiscountLines', resizable: true  },
                    { headerName: 'Total Backbar-rabatt', field: 'TotalBbDiscount', resizable: true  },
                    { headerName: 'Total Arbetsproduktsrabatt', field: 'TotalApDiscount', resizable: true },
                    { headerName: 'Orderkommentar', field: 'OrderComment', resizable: true },
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight',
                animateRows: true,
                pagination: true,
                paginationPageSize: 50,
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }

    download(instance) {
        var $button = $('#downloadExcelBtn');
        var originalText = $button.text();
        $button.prop('disabled', true).text('⏳ Laddar...');

        var startDate = $('#startdate').val();
        var endDate = $('#enddate').val();

        var uri = "/report/GetDiscountReportAsExcel?startDate=" + startDate + "&endDate=" + endDate;
        var fileName = "rabatter-" + startDate + "-" + endDate + ".xlsx";

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";

        x.onload = function (e) {
            download(e.target.response, fileName, "application/vnd.ms-excel");
            $button.prop('disabled', false).text(originalText);
        };

        x.onerror = function () {
            $button.prop('disabled', false).text(originalText);
            alert("Något gick fel vid hämtningen av Excel-filen.");
        };

        x.send();

        if (typeof (callback) === 'function')
            callback();
    }
}